import { render } from "./ProfileReviews.vue?vue&type=template&id=33bfc50b"
import script from "./ProfileReviews.vue?vue&type=script&lang=js"
export * from "./ProfileReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__